// extracted by mini-css-extract-plugin
module.exports = {"tggl":"Toggle_tggl__3WsDs","tggl__checkbox":"Toggle_tggl__checkbox__1Ivvd","tggl__background":"Toggle_tggl__background__2gD85","tggl__button":"Toggle_tggl__button__NWITZ"};